import { get, post } from './common'
type ApiBaseResult = ApiTypes.ApiBaseResult

export namespace user {
  export function getUserInfo(): Promise<ApiBaseResult & { userData: ServerDataTypes.UserInfo }> {
    return get('/user/me')
  }
  export function logout(): Promise<ApiBaseResult> {
    return get('/user/logout')
  }

  // 记录用户访问行为
  export function postVisitorRecord(data: { token: string; actionType: string }) {
    return post('/visitor/record', {}, data)
  }

  export function postUninstallRecord(
    data: ServerDataTypes.UninstallRecordData
  ): Promise<{ recordId: string }> {
    return post('/uninstall_record', {}, data)
  }

  export function checkAlipaySignStatus() {
    return post('/alipay/agree_status')
  }

  export function alipayUnsign() {
    return post('/alipay/unsign_agree')
  }

  export function getEventRecordList(params: {
    offset: number
    limit: number
    //目前只有PDF
    eventType?: ServerDataTypes.EventType
  }): Promise<ApiBaseResult & { data: ServerDataTypes.EventRecordInfo[] }> {
    return get('/event_record/list', params)
  }

  export function getLanguageList(): Promise<
    ApiBaseResult & {
      language_list: {
        [key: string]: { name: string; nativeName: string; chineseName?: string }
      }
    }
  > {
    return post('/language/list', {}, {}, false)
  }

  export function postHuiyiRecord(data: PostDataTypes.UserActionInfo) {
    return post('/user_behavior/burying', {}, data)
  }

  // export function getTranslateModelList(): Promise<
  //   ApiBaseResult & { dataList: ServerDataTypes.Model[] }
  // > {
  //   return get('/llm/model/list')
  // }

  export function getTranslateModelList(
    llmScene: PostDataTypes.LLMScene
  ): Promise<ApiBaseResult & { dataList: ServerDataTypes.Model[] }> {
    return get('/llm/model/list', { llmSence: llmScene })
  }

  export function getGlossaryList(params: {
    keyword: string
  }): Promise<ApiBaseResult & { dataList: ServerDataTypes.GlossaryInfo[] }> {
    return get('/termbase/list', { ...params })
  }

  export function addGlossary(
    data: Omit<ServerDataTypes.GlossaryItem, 'termId' | 'createdAt'>
  ): Promise<ApiBaseResult> {
    return post('/termbase/add', {}, data)
  }

  export function editGlossary(
    data: Omit<ServerDataTypes.GlossaryItem, 'createdAt'>
  ): Promise<ApiBaseResult> {
    return post('/termbase/update', {}, data)
  }

  export function deleteGlossary(params: { termId: number }): Promise<ApiBaseResult> {
    return post('/termbase/del', {}, params)
  }

  export function getOrderList(): Promise<ServerDataTypes.OrderListResponse> {
    return get('/order/list')
  }
}
